
export enum TripEquipmentStatusCd {
	ATTACHED = 'Attached',
	DROPPED = 'Dropped',
	PLANNED = 'Planned',
	PLANNED_FOR_HOOK = 'PlannedForHook',
	RETURNED = 'Returned'}
